import { memo } from "react";
import {
  Accordion,
  Badge,
  Flex,
  Text,
  Title,
  useMantineTheme,
} from "@mantine/core";
import { GetCreditAllotmentManyQuery } from "src/generated/graphql";

interface ClientOverProps {
  creditsData: GetCreditAllotmentManyQuery["creditAllotmentMany"];
}

const Credits = ({ creditsData }: ClientOverProps) => {
  const creditsDataMock = [
    {
      id: "1",
      name: "Variety Yoga",
      count: 28,
      expiresAt: "2023-11-24T19:56:56.236Z",
      agreement: { id: 1, name: "Yoga Plus Agreement" },
      package: null,
      services: [
        { id: 1, name: "Yoga" },
        { id: 2, name: "Spa" },
        { id: 3, name: "Meditation" },
      ],
    },
    {
      id: "2",
      name: "Hydro Massage",
      count: 12,
      expiresAt: "2023-10-24T19:56:56.236Z",
      agreement: null,
      package: { id: 1, name: "Hydro Massage 10 Pack" },
      services: [
        { id: 1, name: "Yoga" },
        { id: 2, name: "Spa" },
        { id: 3, name: "Meditation" },
      ],
    },
    {
      id: "3",
      name: "Hydro Massage Therapy",
      count: 12,
      expiresAt: null,
      agreement: null,
      package: null,
      services: [
        { id: 1, name: "Yoga" },
        { id: 2, name: "Spa" },
        { id: 3, name: "Meditation" },
      ],
    },
  ];
  const theme = useMantineTheme();
  return (
    <>
      <Flex
        align={"center"}
        justify={"space-between"}
        style={{ paddingBottom: "20px", borderBottom: "1px solid" }}
      >
        <Title order={4}>Credits</Title>
      </Flex>
      <Flex direction={"column"}>
        <Accordion
          styles={{
            item: {
              background: theme.colors.primary[6],
              marginTop: "15px",
              borderRadius: "10px",
              border: "0px",
              overflow: "hidden",
            },
            control: {
              color: theme.colors.primaryTextColor[6],
              "&:hover": {
                background: theme.colors.primary[4],
              },
            },
            panel: {
              backgroundColor: theme.colors.secondary[6],
            },
          }}
        >
          {creditsData &&
            creditsData.map((credit) => {
              return (
                <Accordion.Item value={credit.id} key={credit.id}>
                  <Accordion.Control>
                    <Flex justify={"space-between"} align={"center"}>
                      <Flex direction={"column"}>
                        <Text size={14} fw={600}>
                          {credit.name}
                        </Text>
                        <Text size={14} fw={600}>
                          {`${credit.count} Available`}
                        </Text>
                      </Flex>
                      <Flex direction={"column"} align={"flex-end"}>
                        <Text size={12} fw={500}>
                          {credit?.agreement?.name}
                          {credit?.package?.name}
                        </Text>
                        <Text size={12} fw={500}>
                          {credit.expiresAt
                            ? `Expires At: ${new Date(
                                credit.expiresAt
                              ).toLocaleDateString()}`
                            : "No Expiration"}
                        </Text>
                      </Flex>
                    </Flex>
                  </Accordion.Control>
                  <Accordion.Panel>
                    {credit?.services.map((service, index) => {
                      return (
                        <Badge
                          color="primary"
                          variant="filled"
                          mx={5}
                          key={index}
                        >
                          {service.name}
                        </Badge>
                      );
                    })}

                    {credit?.privateSessions.map((detail) => {
                      return (
                        <Badge
                          color="primary"
                          variant="filled"
                          mx={5}
                          key={detail.id}
                        >
                          {detail.session.name} - {detail.duration}
                        </Badge>
                      );
                    })}
                  </Accordion.Panel>
                </Accordion.Item>
              );
            })}
        </Accordion>
      </Flex>
    </>
  );
};

export default memo(Credits);
